import { useState } from "react";
import { useRouter } from "next/router";
import { useTranslations } from "next-intl";
import Cookies from "js-cookie";
import { useUserId } from "./useUserId";
import { devIdCookieName } from "@/constants";
import { submitEmailSubscription, type SubscribeResult } from "@/utils/subscription";

type SubmitEmailOptions = {
	consent?: boolean;
	toastMode?: "default" | "silent";
};

/**
 * Owns the email-alert form state and the metadata the save endpoint needs
 * (device, country, timezone, language), so every email surface reports it consistently.
 */
export function useEmailAlert() {
	const [email, setEmail] = useState("");
	const [emailAlert, setEmailAlert] = useState(false);
	const { userId } = useUserId();
	const router = useRouter();
	const t = useTranslations("Toast.Newsletter");

	const submitEmail = async (options?: SubmitEmailOptions): Promise<SubscribeResult> => {
		return submitEmailSubscription({
			userId,
			deviceId: Cookies.get(devIdCookieName) ?? "",
			email,
			countryCode: Cookies.get("region") || "US",
			timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
			language: router.locale ?? "en",
			email_consent: options?.consent ?? true,
			setEmail,
			successMessage: t("success"),
			errorMessage: t("error"),
			emptyMessage: t("emailEmpty"),
			invalidMessage: t("invalidEmail"),
			toastMode: options?.toastMode ?? "default",
		});
	};

	return { email, setEmail, emailAlert, setEmailAlert, submitEmail };
}
